export enum CountryContext {
    DE = 'DE',
    NL = 'NL',
    SK = 'SK',
    FR = 'FR',
    SE = 'SE',
    LU = 'LU',
    EN = 'EN',
}
